import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/autoplay";
import "swiper/css/scrollbar";
import classNames from "classnames/bind";
import styles from "./BusinessFieldSlider.module.css";

const cx = classNames.bind(styles);

export default function BusinessFieldSlider() {
  const businessFields = [
    {
      title: "화재사고",
      link: "fire",
      img: "/img/fireDisaster.jpg",
    },
    {
      title: "누수사고",
      link: "water",
      img: "/img/waterLeakDisaster.jpg",
    },
    {
      title: "침수사고",
      link: "flood",
      img: "/img/floodingDisaster.jpg",
    },
    {
      title: "붕괴 및 균열사고",
      link: "collapse",
      img: "/img/crackDisaster.jpg",
    },
    {
      title: "폭발사고",
      link: "explosion",
      img: "/img/gasExplosionDisaster.jpg",
    },
    {
      title: "설비 및 기계 손해",
      link: "machine",
      img: "/img/brokenMachineDisaster.jpg",
    },
  ];

  return (
    <Swiper
      className={cx("infoSwiper")}
      modules={[Autoplay, Scrollbar]}
      scrollbar={{
        hide: true,
        draggable: true,
      }}
      slidesPerView={3}
      slidesPerGroup={1}
      spaceBetween={30}
      touchEventsTarget="container" // 빈 공간을 드래그해도 슬라이드 이동 가능하게
      breakpoints={{
        // 0px ~ 1023px (모바일, 태블릿)
        0: { enabled: false }, // Swiper 기능 끄기
        // 1024px 이상 (데스크탑)
        1280: {
          enabled: true, // Swiper 기능 켜기
          slidesPerView: 3,
          slidesPerGroup: 1,
          spaceBetween: 30,
        },
      }}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      }}
      touchRatio={0.8}
      grabCursor={true}
      speed={800}
    >
      {businessFields.map((field, index) => (
        <SwiperSlide key={index} className={cx("infoSlide")}>
          <Link
            to={`/performance/disasters?id=${field.link}`}
            className={cx("infoCard")}
            style={{ backgroundImage: `url('${field.img}')` }}
          >
            <p className={cx("cardTitle")}>{field.title}</p>
            <p className={cx("more")}>MORE →</p>
          </Link>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
